var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Game',{nativeOn:{"contextmenu":function($event){return (function (e) { e.preventDefault(); }).apply(null, arguments)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }